<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Legal information') }}</h1>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                    <router-link
                        class="btn btn-gray shadow-sm rounded"
                        to="/workspace/admin/settings/legal-information/new"
                    >
                        {{ $t('Create legal link') }}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6 bg-white shadow overflow-hidden sm:rounded">
                <loading :status="loading"/>
                <template v-if="legalLinks.length > 0">
                    <ul>
                        <template v-for="(legalLink, index) in legalLinks" :key="legalLink.id">
                            <li :class="{'border-t border-gray-200': index !== 0}">
                                <router-link
                                    :to="'/workspace/admin/settings/legal-information/' + legalLink.id + '/edit'"
                                    class="block hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                >
                                    <div class="flex items-center px-4 py-4 sm:px-6">
                                        <div class="min-w-0 flex-1 flex items-center">
                                            <div class="flex-shrink-0 rounded-full bg-gray-700">
                                                <svg-vue class="w-8 h-8 p-1.5 text-gray-200" icon="regular.shield-keyhole"></svg-vue>
                                            </div>
                                            <div class="min-w-0 flex-1 px-4 lg:grid lg:grid-cols-3 lg:gap-4">
                                                <div class="min-w-0">
                                                    <div class="text-sm font-medium leading-5 text-gray-900 truncate">
                                                        {{ displayTitle(legalLink) }}
                                                    </div>
                                                    <div class="text-xs text-gray-500 mt-1">
                                                        {{ titleSourceLabel(legalLink) }}
                                                    </div>
                                                </div>
                                                <div class="min-w-0 mt-2 lg:mt-0">
                                                    <div class="text-sm text-gray-700 truncate">
                                                        {{ legalLink.url || '-' }}
                                                    </div>
                                                </div>
                                                <div class="min-w-0 mt-2 lg:mt-0">
                                                    <div class="text-sm text-gray-700">
                                                        {{ targetLabel(legalLink.target) }}
                                                    </div>
                                                    <div class="text-xs mt-1" :class="legalLink.is_active ? 'text-green-600' : 'text-gray-500'">
                                                        {{ legalLink.is_active ? $t('Active') : $t('Inactive') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <svg-vue class="h-5 w-5 text-gray-400" icon="font-awesome.angle-right-regular"></svg-vue>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </template>
                <template v-else-if="!loading">
                    <empty-state />
                </template>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "legal-links-list",
    metaInfo() {
        return {
            title: this.$i18n.t('Legal information')
        }
    },
    data() {
        return {
            loading: true,
            legalLinks: [],
        }
    },
    mounted() {
        this.getLegalLinks();
    },
    methods: {
        getLegalLinks() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/admin/legal-links').then(function (response) {
                self.legalLinks = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        displayTitle(legalLink) {
            if (legalLink.title_mode === 'translation') {
                return this.translateIfExists(legalLink.translation_key) || legalLink.translation_key || '-';
            }
            return legalLink.custom_title || '-';
        },
        titleSourceLabel(legalLink) {
            if (legalLink.title_mode === 'translation') {
                return (this.$t('Translation key') + ': ' + (legalLink.translation_key || '-'));
            }
            return this.$t('Custom title');
        },
        targetLabel(target) {
            if (target === '_blank') {
                return this.$t('New tab');
            }
            return this.$t('Same tab');
        },
        translateIfExists(key) {
            const text = String(key || '').trim();
            if (text === '') {
                return '';
            }
            if (typeof this.$te === 'function' && this.$te(text)) {
                return this.$t(text);
            }
            return text;
        },
    }
}
</script>
